import React, { ReactElement } from "react";
import ComponentsList from "../../../../components/Shared/ComponentsList";
import { ComponentTypes } from "../../../../services/http/component/models/ComponentTypes";
import { IComponent } from "../../../../services/http/component/models/IComponent";
import SensorInfo from "./SensorInfo";

interface ComponentTypeProps
{
    component: IComponent;
    children?: IComponent[];
}

function ComponentType(props: ComponentTypeProps): ReactElement
{
    return props.component.componentType === ComponentTypes.NumericalSensor
        ? <SensorInfo component={props.component} />
        : <ComponentsList components={props.children || []} allowTooltips={false} />;
}

export default ComponentType;